import axios from '@/plugins/axios';
import cookie from 'js-cookie';
import md5 from 'md5';
import Vue from 'vue';
import Vuex from 'vuex';
import state from './root/state';
import getters from './root/getters';
import mutations from './root/mutations';
import actions from './root/actions';
import goods from './goods/index';
import information from './information/index';
import cart from './cart/index';
import center from './center/index';

Vue.use(Vuex);

const vm = new Vuex.Store({
  state,
  getters,
  mutations,
  actions,
  modules: {
    goods: {
      namespaced: true,
      state: goods.state,
      getters: goods.getters,
      mutations: goods.mutations,
      actions: goods.actions,
    },
    center: {
      namespaced: true,
      state: center.state,
      getters: center.getters,
      mutations: center.mutations,
      actions: center.actions,
    },
    information: {
      namespaced: true,
      state: information.state,
      getters: information.getters,
      mutations: information.mutations,
      actions: information.actions,
    },
    cart: {
      namespaced: true,
      state: cart.state,
      getters: cart.getters,
      mutations: cart.mutations,
      actions: cart.actions,
    },
  },
});

vm.$http = axios;
vm.$cookie = cookie;
vm.$md5 = md5;

export default vm;
